import React, { Component } from 'react'
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    allPosturePelvis,
    addPosturePelvis,
    editPosturePelvis,
    statusPosturePelvis,
    deletePosturePelvis
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class pelvisposture extends Component {
   
   constructor(props) {
      
      super(props);
        this.confirmationDialog = React.createRef();
         this.state = {
            name: '',
            adddiv:true,
            editdiv:false,
            eid:'',
            edname:'',
         };      
      this.addHandleSubmit = this.addHandleSubmit.bind(this); 
      this.deletePosture = this.deletePosture.bind(this); 
      this.editPosture = this.editPosture.bind(this);
      this.statusPosture = this.statusPosture.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
      
   }

   UNSAFE_componentWillMount() {
		this.props.allPosturePelvis();
	}
   
    addHandleSubmit(event) {
        event.preventDefault();
        this.props.addPosturePelvis(this.state.name);
        this.setState({ 
                        name:''
                    });
    }


    deletePosture(data){
        this.data = data;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
        
        if (popupResponse) {
            this.props.deletePosturePelvis(this.data);
            this.data = ""
        }
    }

   editPosture(rawdata){
      
     
      this.setState({
         eid:rawdata.pplID,
         edname:rawdata.ppl_name,       
         adddiv:false,
         editdiv:true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      this.props.editPosturePelvis(this.state.edname,this.state.eid);      
   }

   
   statusPosture(roleid,status){
      this.props.statusPosturePelvis(roleid,status);       
   }

   onBackSection() {
		this.setState({ adddiv:true,
         editdiv:false });
	}

    render() {
       const { match, mkpelvislists, loading } = this.props;
       return (
          
             <div className="row">
               <div className="col-sm-12 col-md-8">
                  <RctCollapsibleCard heading="List">
                     <div className="table-responsive">
                           <Table hover bordered striped>
                              <thead>
                                 <tr className="bg-primary text-white">
                                    <th>Sl.No</th>
                                    <th>Name</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>                              
                              {mkpelvislists.map((listval,idx) => (
                                 <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{listval.ppl_name}</td>
                                    <td>
                                       {listval.ppl_status==1 ? (
                                          <a herf="" onClick={ ()=>this.statusPosture(listval.pplID,0)}><span className="badge badge-info" >Active</span></a> 
                                       ) : (
                                          <a herf="" onClick={ ()=>this.statusPosture(listval.pplID,1)}><span className="badge badge-danger" >Inactive</span></a> 
                                       )}
                                       <IconButton className="text-info" aria-label="edit" onClick={ ()=>this.editPosture(listval)}><EditOutlinedIcon/></IconButton>
                                       <IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deletePosture(listval.pplID)}><DeleteOutlineOutlinedIcon/></IconButton> 
                                       </td>
                                 </tr>
                              ))}
                                                      
                              </tbody>
                           </Table>
                     </div>
                  </RctCollapsibleCard>
               </div>  
               {this.state.adddiv && 
               <div className="col-sm-6 col-md-4">
                  <RctCollapsibleCard heading="Add Data">
                     <form autoComplete="off" onSubmit={(e)=>this.addHandleSubmit(e)}>
                        <div className="row">
                           <div className="col-sm-12 col-md-6 col-xl-12">
                              <div className="form-group">
                                 <TextField id="name" fullWidth label="Name" required  value={this.state.name} onChange={evt => this.setState({name: evt.target.value})}/>
                              </div>                             
                              <div className="form-group">
                                 <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                              
                              </div>
                           </div>   
                        </div>   
                     </form> 
                  </RctCollapsibleCard>  
               </div>
               }

               {this.state.editdiv && 
               <div className="col-sm-6 col-md-4">                   
                  <RctCollapsibleCard heading="Edit Data">                     
                     <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                        <div className="row">
                           <div className="col-sm-12 col-md-6 col-xl-12">
                              <div className="form-group">
                                 <TextField id="name" fullWidth label="Name" required  value={this.state.edname} onChange={evt => this.setState({edname: evt.target.value})}/>
                              </div>
                              <div className="form-group">
                                 <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                 <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                              
                              </div>
                           </div>   
                        </div>   
                     </form> 
                  </RctCollapsibleCard>  
               </div>
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'data'}
            />
             </div>
       )
    }
 }




const mapStateToProps = ({ mskposture }) => {
	const { mkpelvislists, loading } = mskposture;
	return { mkpelvislists, loading };
}

export default connect(mapStateToProps, {
    allPosturePelvis,
    addPosturePelvis,
    editPosturePelvis,
    statusPosturePelvis,
    deletePosturePelvis
})(pelvisposture); 